
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-upload-modal',
  templateUrl: './file-upload-modal.component.html',
  styleUrls: ['./file-upload-modal.component.scss']
})
export class FileUploadModalComponent {
  @Input() visible: boolean = false;
  @Input() files: File[] = []; // File list
  @Input() uploadLoader: boolean = false; 
  @Output() visibleChange = new EventEmitter<boolean>(); 
  @Output() fileSelected = new EventEmitter<File[]>();
  @Output() fileUploaded = new EventEmitter<void>(); 
  @Output() fileDeleted = new EventEmitter<File>(); 

  onFileSelected(event: any) {
    const selectedFiles: FileList = event.target.files;
    this.fileSelected.emit(Array.from(selectedFiles));
  }

  uploadFilestoserver() {
    this.fileUploaded.emit();
  }

  onDelete(file: File) {
    this.fileDeleted.emit(file);
  }

  onDialogHide() {
    this.files=[];
    this.visibleChange.emit(false); // Close the modal
  }

  getfiletype(filename: string) {
    return filename.split('.').pop()?.toUpperCase();
  }
}
